import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";

export function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-bg px-4 py-14">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[620px] -translate-x-1/2 rounded-full bg-brand-accent/10 blur-[120px]"
      />
      <div className="relative w-full max-w-md">
        <Link to="/" className="mb-9 inline-flex" aria-label="Promptivo — strona główna">
          <Logo height={30} />
        </Link>
        <h1 className="font-display text-3xl font-semibold leading-tight text-brand-text sm:text-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-brand-sec">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-7 text-sm text-brand-sec">{footer}</div>}
      </div>
    </div>
  );
}
